import { Panel } from "@mixitone/components/Controls";
import { buttonClasses } from "@mixitone/components/Styles/Buttons";
import { ApplicationView } from "@mixitone/mvc";
import { ClubDetailsPageController } from "controllers/ClubDetailsPageController";
import { Link } from "react-router-dom";

export const ClubInfoPanel = ApplicationView(() => {
  const controller = ClubDetailsPageController.use();
  const { club, clubPlayer } = controller.state;

  return (
    <Panel title="Club details" titleClassName="font-semibold">
      {club.address && <div>{club.address}</div>}
      {clubPlayer.isCurrentMember && (
        <div className="flex justify-end w-full">
          <Link className={buttonClasses({ kind: "link" })} to={`documents`}>
            View documents
          </Link>
        </div>
      )}
    </Panel>
  );
});
